import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  OnChanges,
  ChangeDetectorRef,
  SimpleChanges,
} from "@angular/core";
import { SharedModule } from "@bb-vendure/admin-ui/core";

@Component({
  standalone: true,
  imports: [SharedModule],
  selector: "custom-pagination-controls",
  templateUrl: "./pagination-controls.component.html",
  styleUrls: ["./pagination-controls.component.scss"],
  //changeDetection : ChangeDetectionStrategy.OnPush
})
export class CustomPaginationControlsComponent implements OnInit, OnChanges {
  ngOnChanges(changes: SimpleChanges): void {
    this.pages = this.createPageArray(
      this.currentPage,
      this.itemsPerPage,
      this.totalItems,
      7
    );

    //console.log("pages",this.pages);
  }

  pages: any[] = [];
  isFirstPage() {
    return this.currentPage === 1;
  }

  next() {
    this.setCurrent(this.currentPage + 1);
  }
  previous() {
    this.setCurrent(this.currentPage - 1);
  }

  setCurrent(page: number) {
    this.pageChange.emit(page);
  }
  isLastPage() {
    const getLastPage = Math.ceil(this.totalItems / this.itemsPerPage);

    return getLastPage === this.currentPage
  }

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {}
  @Input() id?: number;
  @Input() currentPage: number;
  @Input() itemsPerPage: number;
  @Input() totalItems: number;
  @Output() pageChange = new EventEmitter<number>();

  private createPageArray(
    currentPage: number,
    itemsPerPage: number,
    totalItems: number,
    paginationRange: number
  ) {
    // paginationRange could be a string if passed from attribute, so cast to number.
    paginationRange = +paginationRange;
    let pages: any[] = [];

    // Return 1 as default page number
    // Make sense to show 1 instead of empty when there are no items
    const totalPages = Math.max(Math.ceil(totalItems / itemsPerPage), 1);
    const halfWay = Math.ceil(paginationRange / 2);

    const isStart = currentPage <= halfWay;
    const isEnd = totalPages - halfWay < currentPage;
    const isMiddle = !isStart && !isEnd;

    let ellipsesNeeded = paginationRange < totalPages;
    let i = 1;

    while (i <= totalPages && i <= paginationRange) {
      let label;
      let pageNumber = this.calculatePageNumber(
        i,
        currentPage,
        paginationRange,
        totalPages
      );
      let openingEllipsesNeeded = i === 2 && (isMiddle || isEnd);
      let closingEllipsesNeeded =
        i === paginationRange - 1 && (isMiddle || isStart);
      if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)) {
        label = "...";
      } else {
        label = pageNumber;
      }
      pages.push({
        label: label,
        value: pageNumber,
      });
      i++;
    }
    return pages;
  }

  private calculatePageNumber(
    i: number,
    currentPage: number,
    paginationRange: number,
    totalPages: number
  ) {
    let halfWay = Math.ceil(paginationRange / 2);
    if (i === paginationRange) {
      return totalPages;
    } else if (i === 1) {
      return i;
    } else if (paginationRange < totalPages) {
      if (totalPages - halfWay < currentPage) {
        return totalPages - paginationRange + i;
      } else if (halfWay < currentPage) {
        return currentPage - halfWay + i;
      } else {
        return i;
      }
    } else {
      return i;
    }
  }
}
